module.exports = __webpack_public_path__ + "static/img/BG60.2b06e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BG60.png
// module id = 0NGg
// module chunks = 1